import { INavigationItem } from '../view-models/navigation/INavigationItem';

export const useFilteredNavItems = (items?: Array<INavigationItem>, reviewAppUrl?: string) => {
    // this hook is a stop gap to do the custom filtering and pre-pending of Review to the nav items we get from
    // app stack services.
    // also a stop gap for initial icons
    let filteredItems: Array<INavigationItem> = [];

    if (items) {
        // Data Management
        addItemByIdFromSource('fcce6bd3-8a77-45c3-91e0-b0484a294dd1', items, filteredItems, 'DatabaseWindow');

        // Data Import
        addItemByIdFromSource('bb4c677d-430c-410b-af54-45b875271061', items, filteredItems, 'DatabaseWindow');

        // Cart Manager
        addItemByIdFromSource('b5b15af0-c63f-4beb-ab22-e01d4fad2f2c', items, filteredItems, 'Bot');

        // Adjustments
        addItemByIdFromSource('f6f36750-6407-4dbb-a954-fc5f98fcb122', items, filteredItems, 'DocumentPercent');

        // Book To Tax
        addItemByIdFromSource('09e58852-5c52-481c-b1ae-7cd52b4f9bfc', items, filteredItems, 'DatabaseWindow');
    }

    filteredItems.unshift({
        id: '00000000-0000-0000-0000-000000000000',
        displayName: 'Calc Review',
        routeUrl: reviewAppUrl ?? '#',
        iconName: 'CalculationReview',
    });

    return filteredItems;
};

function findItemById(items: Array<INavigationItem>, id: string): INavigationItem | undefined {
    for (let item of items) {
        if (item.id === id) {
            return {
                id: item.id,
                displayName: item.displayName,
                routeUrl: item.routeUrl,
            };
        } else if (item.children && item.children.length > 0) {
            let foundItem = findItemById(item.children, id);
            if (foundItem) {
                return foundItem;
            }
        }
    }
}

function addItemByIdFromSource(id: string, sourceItems: Array<INavigationItem>, targetItems: Array<INavigationItem>, iconName: string) {
    let foundItem = findItemById(sourceItems, id);
    if (foundItem) {
        targetItems.push({ ...foundItem, iconName: iconName });
    }
}
